import { getFontSize } from '../../../../constants/fontSizes';

export const testimonialsSectionStyles = {
  container: {
    width: '100%',
    height: {xs: '100%', lg: '175vh'},
    padding: '5%',
    backgroundColor: '#252629',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center', 
    position: 'relative',
    overflow: 'hidden',
  },
  heading: {
    fontFamily: 'Aurora',
    fontWeight: 700,
    fontSize: getFontSize(233),
    lineHeight: { xs: '50px',
      md: '70px',
      lg: '156px',
      xl: '233px'},
    letterSpacing: 0,
    textAlign: 'center',
    textTransform: 'capitalize',
    background: 'linear-gradient(180.34deg, #FFFFFF 0.3%, #252629 104.2%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    position: 'relative',
    zIndex: 1,
    marginBottom: {xs: '50px', md: '50px', lg: 0},
  },
  cardsContainer: {
    display: {xs: 'flex', sm: 'grid', lg: 'block'},
    flexDirection: {xs: 'column', sm: 'row'},
    gridTemplateColumns: {sm: 'repeat(2, 1fr)'},
    gap: {xs: '20px', sm: '20px', md: '24px', lg: 0},
    width: '100%',
    px: {xs: 1, sm: 1, md: 2, lg: 0},
    position: {xs: 'relative',lg: 'absolute'},
    top: {xs: 'unset', lg: 0},
    left: {xs: 'unset',lg: 0},
    right: {xs: 'unset',  lg: 0},
    bottom: {xs: 'unset',  lg: 0},
  },
  card1: {
    position: {xs: 'relative', sm: 'relative', md: 'relative', lg: 'absolute'},
    top: {xs: 'unset', sm: 'unset', md: 'unset', lg: '5%'},
    right: {xs: 'unset', sm: 'unset', md: 'unset', lg: '7%'},
    zIndex: 2,
    width: {xs: '100%', sm: '100%', md: '100%', lg: 'auto'},
  },
  card2: {
    position: {xs: 'relative', sm: 'relative', md: 'relative', lg: 'absolute'},
    top: {xs: 'unset', sm: 'unset', md: 'unset', lg: '10%'},
    left: {xs: 'unset', sm: 'unset', md: 'unset', lg: '5%'},
    zIndex: 2,
    width: {xs: '100%', sm: '100%', md: '100%', lg: 'auto'},
  },
  card3: {
    position: {xs: 'relative', sm: 'relative', md: 'relative', lg: 'absolute'},
    top: {xs: 'unset', sm: 'unset', md: 'unset', lg: '45%'},
    right: {xs: 'unset', sm: 'unset', md: 'unset', lg: '5%'},
    zIndex: 2,
    width: {xs: '100%', sm: '100%', md: '100%', lg: 'auto'},
  },
  card4: {
    position: {xs: 'relative', sm: 'relative', md: 'relative', lg: 'absolute'},
    top: {xs: 'unset', sm: 'unset', md: 'unset', lg: '60%'},
    left: {xs: 'unset', sm: 'unset', md: 'unset', lg: '10%'},
    zIndex: 2,
    width: {xs: '100%', sm: '100%', md: '100%', lg: 'auto'},
  },
  card5: {
    position: {xs: 'relative', sm: 'relative', md: 'relative', lg: 'absolute'},
    top: {xs: 'unset', sm: 'unset', md: 'unset', lg: '15%'},
    left: {xs: 'unset', sm: 'unset', md: 'unset', lg: '50%'},
    transform: {xs: 'none', lg: 'translateX(-50%)'},
    zIndex: 2,
    width: {xs: '100%', sm: '100%', md: '100%', lg: 'auto'},
  },
  card6: {
    position: {xs: 'relative', sm: 'relative', md: 'relative', lg: 'absolute'},
    top: {xs: 'unset', sm: 'unset', md: 'unset', lg: '52.5%'},
    left: {xs: 'unset', sm: 'unset', md: 'unset', lg: '52%'},
    transform: {xs: 'none', lg: 'translateX(-50%)'},
    zIndex: 2,
    width: {xs: '100%', sm: '100%', md: '100%', lg: 'auto'},
  },
  fadeIn: (isVisible, delay, cardIndex) => {
    // Cards 5 and 6 (indices 2 and 5 in the array) need translateX(-50%) on large screens
    const needsTranslateX = cardIndex === 2 || cardIndex === 5;
    
    let transform;
    if (!isVisible) {
      // Start position: translateY down
      transform = needsTranslateX 
        ? { xs: 'translateY(30px)', lg: 'translateX(-50%) translateY(30px)' }
        : 'translateY(30px)';
    } else {
      // End position: preserve translateX if needed
      transform = needsTranslateX 
        ? { xs: 'none', lg: 'translateX(-50%)' }
        : 'none';
    }
    
    return {
      opacity: isVisible ? 1 : 0,
      transform: transform,
      transition: `opacity 0.8s ease-out ${delay}s, transform 0.8s ease-out ${delay}s`,
    };
  },
};

